import { Component, OnInit, Inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Validators, FormGroup, FormBuilder, ValidatorFn, AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/select';

@Component({
  selector: 'app-pitch-update-dialog',
  imports: [ReactiveFormsModule, MatFormField, NgIf],
  templateUrl: './pitch-update-dialog.component.html',
  styleUrl: './pitch-update-dialog.component.scss',
  standalone: true
})

export class PitchUpdateDialogComponent implements OnInit {
  updateFormGroup: FormGroup = <FormGroup>{};
  
  confirmationResponse: string = '';
  updateConfirmation: boolean = false;
  
  pitchID: string = ''
  pitchName: string = ''
  subassemblyID: string = ''
  variantCount: number = 0
  

  constructor(
    public dialogRef: MatDialogRef<PitchUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public updateData: PitchUpdateDialogData,
    private updateFormBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    console.log(this.updateData)
    console.log(this.updateData.pitch_id)
    
    this.updateData.pitch_id ? this.pitchID = this.updateData.pitch_id: this.pitchID = ''
    this.updateData.pitch_name ? this.pitchName = this.updateData.pitch_name: this.pitchName = ''
    this.updateData.subassembly_id ? this.subassemblyID = this.updateData.subassembly_id: this.subassemblyID = ''
    this.updateData.variant_count ? this.variantCount = this.updateData.variant_count: this.variantCount = 0
    

    this.updateFormGroup = this.updateFormBuilder.group({
      form_updateConfirmation: [(this.confirmationResponse == null)? '' : this.confirmationResponse, [Validators.required, CustomValidators.confirmation]]
    })

    this.updateFormGroup.controls['form_updateConfirmation'].valueChanges.subscribe((value) => {
      if (value == 'YES')
        this.updateConfirmation = true
      else
        this.updateConfirmation = false
      
    })

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirmUpdate(){
    console.log(this.updateConfirmation)
    if (this.updateConfirmation) {
      const pitchUpdateData = {
        confirmation: this.updateConfirmation
      }

      this.dialogRef.close(pitchUpdateData)
    }
  }

}

export class CustomValidators {
  static confirmation: ValidatorFn = (formGroup: AbstractControl) => {
    var isValid: Boolean = false;
    var confirmationValue: string = formGroup.value;
    if(confirmationValue== "YES" ){
      isValid = true;
    }else{
      isValid = false;
      console.log("Confirmation should be typed in as 'YES' ")
    }
    return isValid ? null : { confirmation: true };
  }
}

export interface PitchUpdateDialogData {
  pitch_id: string;
  subassembly_id: string;
  pitch_name: string;
  variant_count: number;
}
